import { sendGTMEvent } from "@next/third-parties/google"

export interface GtmEventPayload {
    event: string
    [key: string]: unknown
}

export function pushGtmEvent(payload: GtmEventPayload) {
    sendGTMEvent(payload)
}
